"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_i18next_1 = require("react-i18next");
var icons_material_1 = require("@mui/icons-material");
var react_1 = require("react");
function SearchBar(_a) {
    var onChange = _a.onChange, advancedSettings = _a.advancedSettings, onClickAdvancedSettings = _a.onClickAdvancedSettings, id = _a.id, noFloating = _a.noFloating, tableMode = _a.tableMode, advancedSelected = _a.advancedSelected, value = _a.value;
    var t = (0, react_i18next_1.useTranslation)().t;
    var textInput = (0, react_1.useRef)(null);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", sx: { backgroundColor: 'transparent' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.TextField, { inputRef: textInput, id: id, variant: noFloating ? 'filled' : 'outlined', label: t('ds.searchLabel'), onChange: function (event) {
                    onChange(event);
                }, value: value, InputProps: {
                    endAdornment: ((0, jsx_runtime_1.jsx)(material_1.InputAdornment, __assign({ position: "end", style: { cursor: value.length > 0 ? 'pointer' : 'default' }, onClick: function () {
                            onChange({
                                target: { value: '' },
                            });
                        } }, { children: value.length > 0 ? ((0, jsx_runtime_1.jsx)(icons_material_1.Close, { sx: { color: 'text.primary' }, fontSize: "medium" })) : ((0, jsx_runtime_1.jsx)(icons_material_1.Search, { sx: { color: 'text.primary' }, fontSize: "medium" })) }))),
                    disableUnderline: true,
                }, InputLabelProps: {
                    sx: {
                        marginTop: '2px',
                        fontSize: '0.8rem',
                    },
                }, sx: {
                    flex: 1,
                    zIndex: 1,
                    backgroundColor: 'secondary.dark',
                    borderRadius: advancedSettings
                        ? '10px 0px 0px 10px'
                        : '10px 10px 10px 10px',
                    minHeight: '52px',
                    '& .MuiFilledInput-root': {
                        backgroundColor: 'transparent',
                    },
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: 'secondary.light',
                            borderRadius: advancedSettings
                                ? '10px 0px 0px 10px'
                                : '10px 10px 10px 10px',
                        },
                        '&:hover fieldset': {
                            borderColor: '#465668',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#465668',
                        },
                        fontSize: {
                            xl: '0.8rem',
                        },
                    },
                } }), advancedSettings && !tableMode && ((0, jsx_runtime_1.jsx)(material_1.Button, __assign({ sx: {
                    height: '52px',
                    width: '67.2px',
                    backgroundColor: advancedSelected
                        ? 'secondary.light'
                        : 'secondary.dark',
                    borderColor: 'secondary.light',
                    borderStyle: 'solid',
                    borderWidth: '1px',
                    marginLeft: '-1px',
                    borderRadius: '0px 10px 10px 0px',
                    color: 'text.primary',
                    '&:hover': {
                        color: 'text.primary',
                        borderColor: 'secondary.light',
                        borderStyle: 'solid',
                        borderWidth: '1px',
                        backgroundColor: 'secondary.light',
                    },
                }, onClick: onClickAdvancedSettings }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(icons_material_1.ManageSearch, { sx: { color: 'text.primary' }, fontSize: "medium" }), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: {
                                fontSize: '10px',
                                marginTop: '-10px',
                                textTransform: 'uppercase',
                                fontWeight: 'normal',
                            } }, { children: t('ds.advancedSearch') }))] }) })))] })));
}
exports.default = SearchBar;
SearchBar.defaultProps = {
    advancedSettings: true,
    noFloating: false,
    onClickAdvancedSettings: function () { },
    tableMode: false,
    advancedSelected: false,
};
//# sourceMappingURL=SearchBar.js.map